import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSidebar } from '../SidebarContext';
import Sidebar from './SideBar';
import Slider2Modal from './Slider2Modal';
import SlideModalEdit2 from './SlideModalEdit2';

const Slider2 = () => {
    const { isSidebarOpen } = useSidebar();

    const [searchQuery, setSearchQuery] = useState('');
    const [amenities, setAmenities] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [inputValue, setInputValue] = useState('');
    const [inputValuelink, setInputValuelink] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [editData, setEditData] = useState({ name: "", image: "", link: "" });
    const [editValue, setEditValue] = useState('');
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [linkError, setLinkError] = useState("");
    

    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const BASE_URL = `${process.env.REACT_APP_LINK}`;

    useEffect(() => {
        fetchAmenities();
    }, []);

    const fetchAmenities = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/slider/getslider/${isLoggedIn.user_id}`);
            setAmenities(response.data.reverse());
        } catch (error) {
            console.error('Error fetching sliders:', error);
        }
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleInputChangeLink = (event) => {
        setInputValuelink(event.target.value);
    };


    const handleInputChange1 = (event) => {
        setEditData({ ...editData, name: event.target.value });
    };

    const handleInputChangeEdit = (event) => {
        setEditData({ ...editData, link: event.target.value });
    };



    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Reset to page 1 on new search
    };

    const handleAddAmenities = async () => {
        if (!inputValue.trim()) {
            alert("Please enter amenity name");
            return;
        }

        const newAmenities = inputValue.split(',').map((amenity) => amenity.trim()).filter((amenity) => amenity !== '');

        // Create FormData for file upload
        const formData = new FormData();
        formData.append('name', newAmenities[0]); // Assuming one amenity for now
        formData.append('status', 'active');
        formData.append('link', inputValuelink);
        formData.append('user_id', isLoggedIn.user_id);
        if (selectedFile) {
            formData.append('image', selectedFile);
        }

        try {
            const response = await axios.post(`${BASE_URL}/slider/add-slider/igothousifyu`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            console.log(response)
            if (response.status === 200) {
                toast.success('New Slider Added');
                fetchAmenities();
                setInputValue('');
                setIsModalOpen(false);
                setSelectedFile(null);
            }

        } catch (error) {
            console.error('Error adding slider:', error);
            toast.error(error);
        }
    };


    const filteredAmenities = amenities.filter((item) =>
        ['name', 'status'].some((key) =>
            String(item[key]).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const totalPages = Math.ceil(filteredAmenities.length / itemsPerPage);
    const currentData = filteredAmenities.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const closeModal1 = () => {
        setIsModalOpen1(false);
    };
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleDelete = async (index) => {
        const amenity = filteredAmenities[(currentPage - 1) * itemsPerPage + index];
        try {
            const response = await axios.delete(`${BASE_URL}/slider/delete-slider/${amenity.id}`);
            if (response.status === 200) {
                toast.success('Slider Deleted');
                fetchAmenities();
            }
        } catch (error) {
            toast.error('Failed to delete');
        }
    };

    const handleEdit = (index) => {
        const slider = amenities[index];
        setEditIndex(index);
        setEditData({ name: slider.name, image: slider.image, link: slider.link });
        setIsEditMode(true);
        setIsModalOpen1(true);
        // Implement edit logic here
    };


    const handleUpdateSlider = async () => {
        const slider = amenities[editIndex];
        const formData = new FormData();
        formData.append("name", editData.name);
        formData.append("link", editData.link);
        if (selectedFile) {
            formData.append("image", selectedFile);
        }

        try {
            let response = await axios.put(`${BASE_URL}/slider/change-slider/${slider.id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (response.status === 200) {
                toast.success('Slider Updated');
                fetchAmenities();
                closeModal1();
            }

        } catch (error) {
            toast.error(error);
            console.error("Error updating slider:", error);
        }
    };

    return (
        <>
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Our Slider</h1>
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Slider
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((amenity, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img src={`${process.env.REACT_APP_LINK}/${amenity.image}`} alt="" style={{ width: '40px', height: "40px", borderRadius: '50%' }} />
                                        </td>
                                        <td>{amenity.name}</td>
                                        <td> {amenity.status.charAt(0).toUpperCase() + amenity.status.slice(1)}</td>
                                        <td>
                                            <button className="edit-button" onClick={() => handleEdit(index)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button className="delete-button" onClick={() => handleDelete(index)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>

                

                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>

            <Slider2Modal isOpen={isModalOpen} setIsOpen={setIsModalOpen} inputValue={inputValue} handleInputChange={handleInputChange} inputValuelink={inputValuelink} handleInputChangeLink={handleInputChangeLink} handleFileChange={handleFileChange} handleAddAmenities={handleAddAmenities} imagePreview={imagePreview} setImagePreview={setImagePreview}/>
            <SlideModalEdit2 isOpen={isModalOpen1} setIsOpen={setIsModalOpen1} inputValue={inputValue} handleInputChange={handleInputChange1} handleFileChange={handleFileChange} handleInputChangeEdit={handleInputChangeEdit} editData={editData} handleUpdateSlider={handleUpdateSlider} closeModal1={closeModal1} />
        </>
    );
};

export default Slider2;
